const WebChatMenus = (that = {}) => {
    return [
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "bubble-settings",
            label: that.$t ? that.$t(`settings.bubble-settings`) : "Bubble Settings",
            icon: {
                type: "material-icons",
                name: "chat_bubble",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "visitor-login-form",
            label: that.$t ? that.$t(`settings.visitorLoginForm`) : "Visitor Login Form",
            icon: {
                type: "material-icons",
                name: "check_box",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "details",
            label:  "Detaylar",
            icon: {
                type: "material-icons",
                name: "settings",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "triggers",
            label: that.$t ? that.$t("message.triggers") : "Triggers",
            icon: {
                type: "material-icons",
                name: "bolt",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "bubble-actions",
            label: that.$t ? that.$t(`settings.bubble-actions`) : "Bubble Actions",
            icon: {
                type: "material-icons",
                name: "build",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "theme-settings",
            label: that.$t ? that.$t(`settings.theme-settings`) : "Theme Settings",
            icon: {
                type: "material-icons",
                name: "settings",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "talk-settings",
            label: that.$t ? that.$t(`settings.talkSettings`) : "Talk Settings",
            icon: {
                type: "material-icons",
                name: "chat",
            },
        },
        {
            get enabled() {
                return that && that.checkPermission("catalog.get");
            },
            key: "catalog",
            label: that.$t ? that.$t(`message.catalogCategories`) : "Catalog",
            icon: {
                type: "material-icons",
                name: "category",
            },
        },
        {
            get enabled() {
                return that.checkPermission("setting.get");
            },
            key: "website-integration",
            label: "Integrations",
            icon: {
                type: "material-icons",
                name: "integration_instructions",
            },
        },
    ];
};
export default WebChatMenus;
